<template>
  <Grid gtc="1fr 1fr" gap="20px" align-items="start">
    <Email :emails="emails" />
    <History :activities="activities" />
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
// Components
import Email from './components/Email'
import History from './components/History'

export default {
  components: { Email, History },

  props: {
    id: [Number, String]
  },

  data: () => ({
    emailsHistory: null,
    isComponentActive: true
  }),

  computed: {
    emails() {
      if (!this.emailsHistory) return
      return this.gatherData('all_emails')
    },

    activities() {
      if (!this.emailsHistory) return
      return this.gatherData('activities')
    }
  },

  created() {
    apiTo.GET_SUBSCRIPTION_EMAIL_HISTORY(this.id).then(({ data }) => (this.emailsHistory = data.result))
  },

  methods: {
    gatherData(field) {
      return this.emailsHistory.reduce((acc, curr) => {
        acc.push(...curr[field])
        return acc
      }, [])
    }
  }
}
</script>
